import { createFileRoute, redirect } from '@tanstack/react-router'

import { OrganizationAdmin } from '~/components/authorize/OrganizationAdmin'
import { isApiKeysEnabled } from '~/constants/featureFlag'
import { ApiKeyDetail } from '~/pages/ApiKeys/detail'

const ApiKeyDetailPage: React.FC = () => {
  const { apiKeyId } = Route.useParams()
  return (
    <OrganizationAdmin thorwError>
      <ApiKeyDetail apiKeyId={apiKeyId} />
    </OrganizationAdmin>
  )
}

export const Route = createFileRoute('/_authenticated/api_keys/$apiKeyId/')({
  beforeLoad: () => {
    if (!isApiKeysEnabled) {
      // redirect() は throw して使うのが TanStack Router の作法
      throw redirect({ to: '/' })
    }
  },
  component: ApiKeyDetailPage,
})
